<ion-app mode="ios">
  <ion-button
    style="visibility: hidden"
    id="hidden-menu-button"
    (click)="openSideMenu()"
  ></ion-button>
  <ion-menu
    side="end"
    type="reveal"
    contentId="main-router-outlet"
    id="main-menu"
  >
    <ion-header>
      <ion-toolbar class="ion-text-center">
        <figure>
          <ion-menu-toggle>
            <img
              routerLink="/"
              routerDirection="none"
              src="/assets/uleagz-white.png"
              alt=""
            />
          </ion-menu-toggle>
        </figure>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="none">
        <ion-menu-toggle *ngIf="!loggedIn">
          <ion-item routerLink="/account/login">
            {{ 'Login' | translate }}
          </ion-item>
        </ion-menu-toggle>
        <ion-item>
          <ion-label>{{ 'Choose Language' | translate }}</ion-label>
          <ion-select
            [(ngModel)]="language"
            (ionChange)="changeLanguage()"
            interface="popover"
          >
            <ion-select-option value="de">
              {{ 'German' | translate }}
            </ion-select-option>
            <ion-select-option value="en">
              {{ 'English' | translate }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ng-container *ngIf="loggedIn">
          <ion-menu-toggle>
            <ion-item routerLink="/account/preferences/edit">
              {{ 'Update Login Details' | translate }}
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item routerLink="/tabs/profile/edit">
              {{ 'Edit Profile' | translate }}
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item (click)="logout()">
              {{ 'Logout' | translate }}
            </ion-item>
          </ion-menu-toggle>
        </ng-container>
      </ion-list>
      <ion-list lines="none">
        <ion-item
          (click)="openUrl('https://uleagz.com/datenschutzerklaerung/')"
        >
          {{ 'Privacy Policy' | translate }}
        </ion-item>
        <ion-item (click)="openUrl('https://uleagz.com/agb/')">
          {{ 'Terms & Conditions' | translate }}
        </ion-item>
        <ion-item (click)="openUrl('https://uleagz.com/impressum/')">
          {{ 'Imprint' | translate }}
        </ion-item>
        <ion-item (click)="openUrl('https://uleagz.com/2020/10/app-tutorial/')">
          {{ 'Tutorial' | translate }}
        </ion-item>
        <ion-item (click)="openUrl('https://uleagz.com/support/')">
          {{ 'Support' | translate }}
        </ion-item>
        <ion-item (click)="openUrl('https://uleagz.com/ueber-uleagz/')">
          {{ 'About ULEAGZ' | translate }}
        </ion-item>
        <ion-item *ngIf="loggedIn" (click)="openDeleteAccountDialog()">
          {{ 'Delete Account' | translate }}
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-router-outlet"></ion-router-outlet>
</ion-app>
